export default {"src":"/_next/static/media/bitcoin.fdaa3ece.svg","height":4092,"width":4091};